import request from '@/utils/request';

/**
 * 获取登录logo
 * @returns
 */
export function getLoginLogo (params) {
  return request({
    url: '/tenant/base_info',
    method: 'get',
    params
  });
}

/**
 * 获取导航logo
 * @returns
 */
export function getHeaderLogo (params) {
  return request({
    url: '/tenant/base_info',
    method: 'get',
    params
  });
}

/**
 * 专利局id
 * @returns
 */
export function getPatentOffice () {
  return request({
    url: '/patent_office',
    method: 'get'
  });
}

/**
 * 字典
 * @returns
 */
export function getDict (type) {
  return request({
    url: '/dict/' + type,
    method: 'get'
  });
}

/**
 * 登录
 * @returns
 */
export function login (data) {
  return request({
    url: '/login/password?t=' + new Date().getTime(),
    method: 'post',
    data
  });
}

/**
 * 获取用户角色
 * @returns
 */
export function getUserRole (params) {
  return request({
    url: '/authentication/info?t=' + new Date().getTime(),
    method: 'get',
    params
  });
}

/**
 * 获取当前用户租户信息及有效合同信息
 * @returns
 */
export function getUserContract (params) {
  return request({
    url: '/tenant_contract',
    method: 'get',
    params
  });
}

/**
 * 根据访问地址获取租户菜单
 * @returns
 */
export function getTenantMenu (params) {
  return request({
    url: '/tenant/menu',
    method: 'get',
    params
  });
}

/**
 * 退出
 * @returns
 */

export function logout () {
  return request({
    url: '/logout?t=' + new Date().getTime(),
    method: 'delete'
  });
}

/**
 * 试用申请
 * @returns
 */

export function application (data) {
  return request({
    url: '/trail/application',
    method: 'post',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/user.js